// extracted by css-extract-rspack-plugin
export default {"item":"vmXRi","label":"VGNmr","highlighted":"OY3LQ","column":"nr1AG"};